import DeliveryMethodDetail from './OrderStateDetail';

export default DeliveryMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/OrderStates/OrderStateDetail/index.ts